import type { IconProps as Props } from './types';

export const IconBookingExperience = ({
  className,
  width = '48',
  height = '48',
  stroke = 'currentColor',
  strokeWidth = '2.5',
  fill = 'none',
  ...props
}: Props) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M33.433 14.5714C32.7199 13.8581 32.3024 12.9019 32.2639 11.894C32.2255 10.8861 32.5689 9.9009 33.2255 9.13533C33.2798 9.07166 33.3081 8.98981 33.3046 8.9062C33.3011 8.82259 33.2661 8.74339 33.2067 8.68447L29.4241 4.89759C29.3616 4.8351 29.2768 4.79999 29.1884 4.79999C29.1 4.79999 29.0152 4.8351 28.9526 4.89759L22.9235 10.9268C22.701 11.1492 22.5334 11.4203 22.434 11.7188V11.7188C22.335 12.0179 22.1676 12.2898 21.9452 12.513C21.7228 12.7362 21.4514 12.9045 21.1526 13.0045V13.0045C20.854 13.104 20.5825 13.2716 20.3597 13.4939L4.89765 28.9526C4.83516 29.0151 4.80005 29.0999 4.80005 29.1883C4.80005 29.2767 4.83516 29.3615 4.89765 29.424L8.68025 33.2066C8.73916 33.2661 8.81836 33.301 8.90198 33.3045C8.98559 33.308 9.06743 33.2798 9.13111 33.2255C9.89651 32.5681 10.882 32.2241 11.8902 32.2624C12.8984 32.3006 13.855 32.7182 14.5684 33.4317C15.2818 34.1451 15.6994 35.1017 15.7377 36.1099C15.7759 37.1181 15.4319 38.1035 14.7746 38.8689C14.7203 38.9326 14.692 39.0144 14.6955 39.0981C14.699 39.1817 14.734 39.2609 14.7934 39.3198L18.576 43.1024C18.6385 43.1649 18.7233 43.2 18.8117 43.2C18.9001 43.2 18.9849 43.1649 19.0474 43.1024L34.5104 27.6403C34.7328 27.4175 34.9003 27.1461 34.9998 26.8474V26.8474C35.0989 26.5483 35.2662 26.2764 35.4887 26.0532C35.7111 25.83 35.9825 25.6617 36.2813 25.5617V25.5617C36.5797 25.4623 36.8509 25.2947 37.0733 25.0723L43.1024 19.0431C43.1649 18.9806 43.2001 18.8958 43.2001 18.8074C43.2001 18.719 43.1649 18.6342 43.1024 18.5717L39.3199 14.7891C39.2609 14.7296 39.1817 14.6947 39.0981 14.6912C39.0145 14.6877 38.9327 14.7159 38.869 14.7702C38.1045 15.428 37.1199 15.7729 36.112 15.736C35.1042 15.6992 34.1474 15.2832 33.433 14.5714V14.5714Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.5283 14.0951L22.1132 12.68"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.7429 20.1437L28.8 19.2"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.3219 25.8865L33.9067 24.4714"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
